import { formatDate, formatMoney } from '@bixo/ui'
import type { ColumnType } from './types'

/** ₹ in the Indian short scale for axes: 950, 12.5K, 3.4L, 1.2Cr. */
export function compactInr(value: number): string {
  const abs = Math.abs(value)
  const sign = value < 0 ? '-' : ''
  if (abs >= 1e7) return `${sign}₹${trim(abs / 1e7)}Cr`
  if (abs >= 1e5) return `${sign}₹${trim(abs / 1e5)}L`
  if (abs >= 1e3) return `${sign}₹${trim(abs / 1e3)}K`
  return `${sign}₹${Math.round(abs)}`
}

const trim = (n: number): string => (n >= 100 ? n.toFixed(0) : n.toFixed(1).replace(/\.0$/, ''))

export function formatValue(type: ColumnType, value: unknown): string {
  if (value === null || value === undefined || value === '') return '—'
  switch (type) {
    case 'money':
      return formatMoney(String(value))
    case 'qty': {
      const n = Number(value)
      return Number.isFinite(n) ? n.toLocaleString('en-IN', { maximumFractionDigits: 3 }) : String(value)
    }
    case 'pct': {
      const n = Number(value)
      return Number.isFinite(n) ? `${n.toFixed(1)}%` : '—'
    }
    case 'int':
      return Number(value).toLocaleString('en-IN')
    case 'date':
      return formatDate(String(value))
    default:
      return String(value)
  }
}
